import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Route } from 'router/Route';

import { AsyncReducerStatus } from 'store/common/AsyncReducerStatus';
import { useTypedSelector } from 'store/common/TypedSelector';
import { deleteReport } from 'services/report/store/reportSlice';
import { ModalDialogue } from 'presentation/ui/compositions/modal-dialogue/ModalDialogue';
import { ModalDialogueHeight } from 'presentation/ui/compositions/modal-dialogue/ModalDialogueHeight';
import { ReportViewModel } from 'services/report/domain/model/ReportModel';
import { useContext } from 'react';
import { ClientContext } from 'services/core/context/ClientContext';
import { FacilityContext } from 'services/core/context/FacilityContext';
import { ReportDeleteModalFailed } from './ReportDeleteModalFailed';
import { ReportDeleteForm } from '../report-delete-form/ReportDeleteForm';

export interface ReportDeleteModalProps {
	report: ReportViewModel
	onDismiss?: () => void;
}

export const ReportDeleteModal = (props: ReportDeleteModalProps): JSX.Element => {
	const { report, onDismiss } = props;

	// Consume the context
	const clientContext = useContext(ClientContext);
	const facilityContext = useContext(FacilityContext);

	const reportActionStatus = useTypedSelector(state => state.reports.actionStatus);

	const history = useHistory();
	const dispatch = useDispatch();

	const handleDelete = (): void => {
		dispatch(deleteReport({
			clientUuid: clientContext.selectedClientUuid,
			facilityUuid: facilityContext.selectedFacilityUuid,
			viewModel: report
		}));
		history.push(Route.REPORTS);
	};

	const renderModalContent = () => {
		switch (reportActionStatus) {
			case AsyncReducerStatus.IDLE:
				return <ReportDeleteForm
					report={report}
					onDelete={handleDelete}
					onDismiss={onDismiss}
				/>;

			case AsyncReducerStatus.FAILED:
				return <ReportDeleteModalFailed
					onDismiss={onDismiss}
				/>;
			default: return null;
		}
	};

	return (
		<ModalDialogue height={ModalDialogueHeight.HEIGHT_FLEX}>
			{renderModalContent()}
		</ModalDialogue>
	);
};
